/**
 * Copyright Han Lee <hanlee.dev@gmail.com> and other contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import HWPChar from './char'
import ShapePointer from './shapePointer'
import LineSegment from './lineSegment'
import { Control } from './controls'

class Paragraph {
  content: HWPChar[] = []

  shapeBuffer: ShapePointer[] = []

  controls: Control[] = []

  lineSegments: LineSegment[] = []

  shapeIndex: number = 0

  aligns: number = 0

  textSize: number = 0

  getShapeEndPos(index: number): number {
    if (index === this.shapeBuffer.length - 1) {
      return this.content.length - 1
    }

    return this.shapeBuffer[index + 1].pos - 1
  }

  getNextSize(index: number): number {
    const next = this.lineSegments[index + 1]

    if (!next) {
      return this.textSize
    }

    return next.start
  }
}

export default Paragraph
